import {
    GET_ALL_NEWS,
    CURRENT_PAGE_NEWS
} from './constants';


const initialState = {
    allNews: [],
    pages: 1,
    currentPageNews: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_NEWS: {
            return {
                ...state,
                allNews: action.payload.items,
                pages: action.payload.pages,
            };
        }
        case CURRENT_PAGE_NEWS: {
            return {
                ...state,
                currentPageNews: action.payload
            };
        }
        default:
            return state;
    }
};

